import { useState, useRef, useEffect } from "react";

const HIGHLIGHT_COLORS = [
  { name: "Amarillo", value: "#FFFF00" },
  { name: "Naranja", value: "#FFA500" },
  { name: "Celeste", value: "#00FFFF" },
  { name: "Verde claro", value: "#90EE90" },
  { name: "Rosa", value: "#FFB6C1" },
];

export const HighlightPickerDropdown = ({ editor }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Hook siempre arriba
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!editor) return null;

  const currentHighlight = editor.getAttributes("highlight")?.color || "";

  return (
    <div style={{ position: "relative" }} ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          padding: "4px 8px",
          cursor: "pointer",
          borderRadius: "4px",
          border: "1px solid #ccc",
          background: "#f7f7f7",
        }}
      >
        🖌 Fondo
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "36px",
            left: 0,
            background: "white",
            border: "1px solid #ccc",
            borderRadius: "8px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            padding: "12px",
            display: "grid",
            gridTemplateColumns: "repeat(4, 24px)",
            gap: "10px",
            zIndex: 999,
          }}
        >
          {HIGHLIGHT_COLORS.map((c) => (
            <button
              key={c.value}
              onClick={() => {
                editor.chain().focus().setHighlight({ color: c.value }).run();
                setOpen(false);
              }}
              title={c.name}
              style={{
                width: "24px",
                height: "24px",
                borderRadius: "4px",
                backgroundColor: c.value,
                border:
                  currentHighlight === c.value
                    ? "3px solid #555"
                    : "1px solid #ccc",
                cursor: "pointer",
              }}
            />
          ))}

          {/* Botón Reset */}
          <button
            onClick={() => {
              editor.chain().focus().unsetHighlight().run();
              setOpen(false);
            }}
            style={{
              gridColumn: "span 4",
              padding: "4px 6px",
              fontSize: "12px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              cursor: "pointer",
              background: "#f5f5f5",
            }}
          >
            Sin fondo
          </button>
        </div>
      )}
    </div>
  );
};
